import { achievementsActionTypes } from './constants';

import type { Category } from '@/pages/freePlay/types';
import type { CategoryAchievements } from '../types';

export function getCategoriesRequest(categoryName: string) {
	return {
		type: achievementsActionTypes.GET_CATEGORIES_REQUEST,
		payload: {
			categoryName,
		},
	};
}

export function getCategoriesSuccess(categories: Category[]) {
	return {
		type: achievementsActionTypes.GET_CATEGORIES_SUCCESS,
		payload: {
			categories,
		},
	};
}

export function getCategoriesError(error: any) {
	return {
		type: achievementsActionTypes.GET_CATEGORIES_ERROR,
		payload: {
			error,
		},
	};
}

export function getAchievementsRequest() {
	return {
		type: achievementsActionTypes.GET_ACHIEVEMENTS_REQUEST,
	};
}

export function getAchievementsSuccess(achievements: Record<number, CategoryAchievements>) {
	return {
		type: achievementsActionTypes.GET_ACHIEVEMENTS_SUCCESS,
		payload: {
			achievements,
		},
	};
}

export function getAchievementsError(error: any) {
	return {
		type: achievementsActionTypes.GET_ACHIEVEMENTS_ERROR,
		payload: {
			error,
		},
	};
}

export function setActiveCategoryId(categoryId: number) {
	return {
		type: achievementsActionTypes.SET_ACTIVE_CATEGORY_ID,
		payload: {
			categoryId,
		},
	};
}

export function resetAchievements() {
	return {
		type: achievementsActionTypes.RESET_ACHIEVEMENTS,
	};
}
